module.exports = __webpack_public_path__ + "static/media/cuperhidro.d6530deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/xanthomonas_tomate/preventiva/cuperhidro.png
// module id = 2405
// module chunks = 3